import { gstConstants } from "../../constants";
import { gstService } from "../../services";
import { alertActions } from "../alert.actions";

export const gstActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    gstService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: gstConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: gstConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: gstConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, code) {
  return (dispatch) => {
    dispatch(request(name, code));

    gstService.addParameter(name, code).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: gstConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: gstConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: gstConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, code) {
  return (dispatch) => {
    dispatch(request(id, name, code));

    gstService.updateParameter(id, name, code).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: gstConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: gstConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: gstConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    gstService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: gstConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: gstConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: gstConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: gstConstants.CLEAR };
}
